export default "__VITE_ASSET__8c4a44fa__"